<!-- 商品展示单个 -->
<template>
  <div class="font_0 bg_lucency2">
    <!-- pc -->
    <div v-if="type === 'pc'" @click="goods_click"
      :style="{ backgroundImage: `url(${obj.cover_PC ? obj.cover_PC : 'https://wozhike-1306886396.cos.ap-nanjing.myqcloud.com/cimg/0545246171.jpg'})` }"
      class="goods_group p_hover_zoom p_hand border_radius2">
      <!-- <el-image :lazy="true" style="width: 560px; height: 560px" src="https://wozhike-1306886396.cos.ap-nanjing.myqcloud.com/cimg/0545246171.jpg"></el-image> -->
      <div class="goods_content">
        <div class="goods_name color_ffffff font_36">
          <span class="font_misans" v-if="GET_LANG2 === 'cn'">{{ obj.productNameCn }}</span>
          <span class="font_misans" v-if="GET_LANG2 === 'en'">{{ obj.productNameEn }}</span>
          <span class="font_misans" v-if="GET_LANG2 === 'jp'">{{ obj.productNameJp }}</span>
          <public-statuscard  type='pc2'
            :sellStatusID='obj.sellStatusID'></public-statuscard>
        </div>
        <div class="goods_tags color_ffffff">
          <span
            v-for="(item, index1) in (GET_LANG2 === 'cn' ? obj.keyWordCn : GET_LANG2 === 'en' ? obj.keyWordEn : obj.keyWordJp).split(',')"
            :key="index1" class="goods_tags_item border_radius12 font_12" :class="item ? '' : 'p_hidden'">
            {{ item }}
          </span>
        </div>
        <!-- <a :href="obj.taobaoLink" @click.stop target="_blank" v-if="obj.sellStatusID === 2 || obj.sellStatusID === 3"
          class="goods_btn p_hand font_15 bg_DC000C border_radius6 p_text_center">
          {{ $t('goods.buybtn') }}
        </a> -->
      </div>
    </div>
    <!-- h5 -->
    <div v-if="type === 'h5'" @click="goods_click"
      :style="{ backgroundImage: `url(${obj.cover_PC ? obj.cover_PC : 'https://wozhike-1306886396.cos.ap-nanjing.myqcloud.com/cimg/0545246171.jpg'})` }"
      class="goods_group_h5 p_hand">
      <div class="goods_content_h5">
        <div class="goods_name_h5 color_ffffff font_24">
          <span class="font_misans" v-if="GET_LANG2 === 'cn'">{{ obj.productNameCn }}</span>
          <span class="font_misans" v-if="GET_LANG2 === 'en'">{{ obj.productNameEn }}</span>
          <span class="font_misans" v-if="GET_LANG2 === 'jp'">{{ obj.productNameJp }}</span>
          <public-statuscard style="position: relative;top: -.15rem;"  type='h5'
            :sellStatusID='obj.sellStatusID'></public-statuscard>
          <!-- <span v-if="obj.sellStatusID === 2"
            class="p_diamond bg_DC000C font_12">{{ $t('goods.sellstatus_yushou') }}</span>
          <span v-if="obj.sellStatusID === 3"
            class="p_diamond bg_DC000C font_12">{{ $t('goods.sellstatus_xianhuo') }}</span> -->
        </div>
        <div class="goods_tags_h5 color_ffffff">
          <span
            v-for="(item, index1) in (GET_LANG2 === 'cn' ? obj.keyWordCn : GET_LANG2 === 'en' ? obj.keyWordEn : obj.keyWordJp).split(',')"
            :key="index1" class="goods_tags_item_h5 border_radius12 font_12 font_500" :class="item ? '' : 'p_hidden'">
            {{ item }}
          </span>
        </div>
        <!-- <a :href="obj.taobaoLink" @click.stop target="_blank" v-if="(obj.sellStatusID === 2 || obj.sellStatusID === 3)&&GET_PLATFORM!=='xcx'"
          class="goods_btn_h5 p_hand font_15 bg_DC000C border_radius6 p_text_center">
          {{ $t('goods.buybtn') }}
        </a> -->
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex';
  export default {
    data() {
      return {};
    },
    props: {
      obj: {
        type: Object,
        default: () => {
          return {};
        }
      },
      type: {
        type: String,
        default: 'pc'
      }
    },
    computed: {
      ...mapGetters('setting', ['GET_LANG2','GET_PLATFORM'])
    },
    methods: {
      goods_click() {
        //console.log(this.obj);
        let path = this.$route.path;
        console.log(path);
        if (path === '/products') {
          this.$router.push('/productInfo/' + this.obj.productId);
        } else if (path === '/peripherals') {
          this.$router.push('/peripheralInfo/' + this.obj.productId);
        }
      }
    }
  };
</script>

<style scoped="scoped">
  .p_hover_zoom {
    transition: all 200ms;
  }

  .p_hover_zoom:hover {
    transition: all 500ms ease-in-out;
    background-size: 105% 105%;
    background-position: center;
  }

  .goods_group {
    position: relative;
    width: 29vw;
    height: 29vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    margin: 60px 0 0px 60px;
  }

  .goods_content {
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 29vw;
    z-index: 33;
    min-height: 100px;
    padding: 0 30px 0 30px;
  }

  .goods_name {
    padding-bottom: 30px;
  }

  .goods_tags {
    width: 100%;
    min-height: 20px;
    padding-bottom: 10px;
  }

  .goods_tags_item {
    padding: 4px 10px;
    min-width: 20px;
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.3);
    margin: 0 20px 20px 0;
  }

  .goods_btn {
    display: block;
    width: 140px;
    height: 42px;
    line-height: 42px;
    margin-bottom: 30px;
    color: #fff;
    text-decoration:none;
  }

  .goods_btn:hover {
    color: #fff;
  }

  .p_diamond {
    display: inline-block;
    min-width: 48px;
    padding: 0 10px;
    height: 24px;
    line-height: 24px;
    border-radius: 5px;
    margin-left: 10px;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    transform: skew(-20deg);
  }

  /* h5 */
  .goods_group_h5 {
    position: relative;
    width: calc(100vw - 30px);
    height: calc(100vw - 30px);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 15px auto;
  }

  .goods_content_h5 {
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100vw - 30px);
    z-index: 33;
    min-height: 50px;
    padding: 0 15px 0 15px;
  }

  .goods_name_h5 {
    padding-bottom: 15px;
  }

  .goods_tags_h5 {
    width: 100%;
    min-height: 20px;
    /* padding-bottom: 10px; */
  }

  .goods_tags_item_h5 {
    padding: 4px 10px;
    min-width: 20px;
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.3);
    margin: 0 15px 15px 0;
  }

  .goods_btn_h5 {
    display: block;
    width: 120px;
    height: 42px;
    line-height: 42px;
    margin-bottom: 15px;
    color: #fff;
  }

  .goods_btn_h5:hover {
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-goodscards/public-goodscards.vue